import { render } from "./WCLoginGreeter.vue?vue&type=template&id=ab575102&ts=true"
import script from "./WCLoginGreeter.vue?vue&type=script&lang=ts"
export * from "./WCLoginGreeter.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__